// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fd05ebbf","456":"17fb2929","750":"30b1254c","860":"8ca17cc0"}[chunkId] + ".chunk.js";
};